import {
  businessCenterIconv1,
  commandCenterIconV1,
  keapMaxIcon,
  marketingCenterIconv1,
  reportingCenterIconv1,
  socialAdsIcon,
  workforceCenterIconv1,
  thryvGrowthPlatformIcon,
  geoAddOnIcon,
} from '../../../assets'

export const COUNTRIES = [
  {name: 'United States', value: 'US'},
  {name: 'Australia', value: 'AU'},
  {name: 'Cayman Islands', value: 'KY'},
  {name: 'Barbados', value: 'BB'},
  {name: 'Canada', value: 'CA'},
  {name: 'New Zealand', value: 'NZ'},
  {name: 'Great Britain', value: 'GB'},
  {name: 'Spain', value: 'ES'},
  {name: 'Italy', value: 'IT'},
  {name: 'India', value: 'IN'},
  {name: 'Philippines', value: 'PH'},
  {name: 'Vietnam', value: 'VN'},
  {name: 'Greece', value: 'GR'},
]

export const PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'Bank Transfer with ACH', value: 'ach', icon: 'landmark'},
]

export const AUS_PAYMENT_METHODS = [
  {name: 'Invoice', value: 'invoice', icon: 'memoCheck'},
  {name: 'Card', value: 'card', icon: 'creditCard'},
  {name: 'BECS', value: 'becs', icon: 'landmark'},
]

export const NZ_PAYMENT_METHODS = [
  {name: 'Invoice', value: 'invoice', icon: 'memoCheck'},
  {name: 'Card', value: 'card', icon: 'creditCard'},
]

export const CA_PAYMENT_METHODS = [
  {name: 'Card', value: 'card', icon: 'creditCard'},
]

export {OOE_SERVICE_URL as REACT_APP_OOE_SERVICE_URL} from '../../../utils/api-base'
export const ONE_TIME_FEES = [
  '5 extra website pages',
  'professional designed logo',
  'onboarding fee',
  'website design fee',
  'custom video shoot',
  'thryv ignite implementation',
  'advanced crm data import',
  'advanced data transfer',
  'ask the expert',
  'basic crm data import',
  'credit card import',
  'data restore',
  'e-commerce data import',
  'e-commerce data transfer',
  'hourly data service',
  'limited e-commerce crm import',
  'custom done for you',
  'thryv vertical services',
  'thryv vertical and mc services & design',
  'thryv vertical and mc services',
  'vertical and mc services & design',
  'vertical and mc services',
  'vertical services',
  'quick launch',
]

export const INITIAL_PAYMENT_STATE = {
  paymentMethod: PAYMENT_METHODS[0],
  paymentInfo: undefined,
  calculatedTaxes: null,
  totalPaymentAmount: 0,
  totalPaymentAmountNoTaxes: 0,
  semiAnnuallyAmount: 0,
  monthlyAmount: 0,
  oneTimeAmount: 0,
  annualAmount: 0,
  annualAddons: [],
  monthlyAddons: [],
  semiAnnuallyAddons: [],
  oneTimeAddons: [],
  taxes: {
    monthly: null,
    semiAnnually: null,
    oneTime: null,
  },
}

export const PLANS_ICONS = [
  {
    name: 'my account',
    icon: commandCenterIconV1,
  },
  {
    name: 'business center',
    icon: businessCenterIconv1,
  },
  {
    name: 'marketing center',
    icon: marketingCenterIconv1,
  },
  {
    name: 'reporting center',
    icon: reportingCenterIconv1,
  },
  {
    name: 'workforce center',
    icon: workforceCenterIconv1,
  },
  {
    name: 'keap max',
    icon: keapMaxIcon,
  },
  {
    name: 'geo add-on',
    icon: geoAddOnIcon,
  },
  {
    name: 'thryv geo expansion',
    icon: geoAddOnIcon,
  },
  {
    name: 'starter (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'signature (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'premier (monthly)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'starter (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'signature (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'premier (annual)',
    icon: thryvGrowthPlatformIcon,
  },
  {
    name: 'coach builder',
    icon: keapMaxIcon,
  },
  {
    name: 'social ads bni',
    icon: socialAdsIcon,
  },
  {
    // FULSAS-12283: covers "Visibility Boost", "Visibility Boost - Social
    // Posts", and "Visibility Boost - Blog Creation" via substring match.
    // Reuses the Social Ads icon as a placeholder until Product supplies a
    // dedicated Visibility Boost icon.
    name: 'visibility boost',
    icon: socialAdsIcon,
  },
  {
    // FULSAS-12281: "Blog Creation" (ent-5-mc-blog-creation) doesn't contain
    // "visibility boost", so it needs its own entry or it renders a broken
    // image. Reuses the Social Ads icon as a placeholder, same as above,
    // until Product supplies a dedicated icon.
    name: 'blog creation',
    icon: socialAdsIcon,
  },
]

// Product codes whose name keeps the "Thryv" prefix in the payment order summary
// (every other mc_*/keap/vert_/max product has it stripped).
export const KEEP_THRYV_PREFIX_PRODUCT_CODES = ['mc_pro_enh-5-thryv-m2m']
